import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ReviewsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Reviews</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">CSSBuy Reviews</h1>
            <p className="text-foreground-600 text-lg">Independent reviews and analysis of CSSBuy services.</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-6">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">CSSBuy Review 2026</h2>
              <p className="text-foreground-700 mb-4">An independent look at CSSBuy&apos;s services, covering shipping, QC, warehouse, costs, and overall user experience. This review is based on publicly available information and user feedback.</p>
              <a href="/cssbuy-spreadsheet" className="text-primary-600 hover:text-primary-700 font-medium text-sm">Read more in our complete guide</a>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Is CSSBuy Legit?</h2>
              <p className="text-foreground-700 mb-4">CSSBuy is a known shopping agent service that has been operating for several years. Like any service, experiences vary. We recommend researching thoroughly, checking recent reviews, and starting with small orders.</p>
            </div>
            <div className="text-center mt-8">
              <a href="/" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                Back to Homepage
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}